
















































































import {FoundProducts, FoundProductsFilter} from "@/model/find-products-response";
import {ProductListFilter} from "@/model/product-list-filter";
import {Util} from "@/util/util";
import {filter} from "rxjs/operators";
import Vue from "vue";
import ProductRangeFilter from "../filters/RangeFilter.vue";
import ProductSelectFilter from "../filters/SelectFilter.vue";

// this is a hack as the backend can't provide this information correctly for now
const RANGE_FILTERS = ["rollingCircumference", "diameter", "width"];

export default Vue.extend({
    name: "ProductFilters",
    components: {
        "product-select-filter": ProductSelectFilter,
        "product-range-filter": ProductRangeFilter
    },
    data() {
        return <{
            filterableFilters: Array<string>
            showSecondaryFilters: boolean
        }>{
            filterableFilters: Util.getFilterableFilters(),
            showSecondaryFilters: false
        };
    },
    props: {
        activeFilter: {
            type: Object as () => ProductListFilter,
            required: true
        },
        foundProducts: {
            type: Object as () => FoundProducts,
            required: true
        },
        v2Styling: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        activeFilter() {
        },
        foundProducts() {
        }
    },
    mounted() {
    },
    computed: {
        primaryFilters(): FoundProductsFilter[] {
            if (this.foundProducts == null) return [];

            const filters = this.filterableFilters.slice(0, 3)
                .map(filterName => {
                    if (this.foundProducts.filters[filterName] == null) {
                        console.warn("Primary filters not found for key", filterName);
                    }
                    return this.foundProducts.filters[filterName];
                })
                .filter(filters => filters != null);

            //console.debug("Primary filters are", filters);
            return filters;
        },
        secondaryFilters(): FoundProductsFilter[] {
            if (this.foundProducts == null) return [];

            const filters = this.filterableFilters.slice(3)
                .map(filterName => {
                    if (this.foundProducts.filters[filterName] == null) {
                        console.warn("Secondary filters not found for key", filterName);
                    }
                    return this.foundProducts.filters[filterName];
                })
                .filter(filters => filters != null);

            //console.debug("Secondary filters are", filters);
            return filters;
        }
    },
    methods: {
        isRangeFilter(filterName: string) {
            return RANGE_FILTERS.includes(filterName);
        },
        toggleShowMoreFilters() {
            this.showSecondaryFilters = !this.showSecondaryFilters;
            // console.log('DIVS: ' + Array.prototype.slice.call(document.getElementsByTagName("main")))
            document.getElementsByTagName("main")[0].classList.toggle("filters-shown");
        }

    }
});
